import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "app-modal",
    templateUrl: "./modal.component.html",
    styleUrls: ["./modal.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit {
    @Input() public dismissable: boolean = true;
    @Input() public withBox: boolean = false;
    @Input() public table: boolean = false;

    @Output() public modalClose: EventEmitter<void> = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}
}
